import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { ForPaintServicedeskSidebar as AsyncForPaintSidebarServiceDesk } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { queuesNavigationItems } from '@atlassian/jira-router-resources-service-desk-queues/src/services/index.tsx';
import { issueNavigatorProjectListServicedeskRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/issueNavigatorProjectListServicedeskRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { issueNavigatorWithoutHorizontalNavPageEntryPoint } from './ui/index.tsx';

/**
 * Servicedesk Project Issue Navigator Route Entry
 * Handles JSM (Service management) projects, also known JSD (Servicedesk) projects.
 */
export const issueNavigatorProjectListServicedeskRouteEntry = createEntry(
	issueNavigatorProjectListServicedeskRoute,
	() => ({
		group: 'issue-navigator',
		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},
		skeleton: ProjectIssueNavigatorSkeleton,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncForPaintSidebarServiceDesk,
		},
		resources: [
			...getCommonProjectResources(),
			queuesNavigationItems,
			getConsolidationStateResource(),
		],
		layout: serviceProjectLayout,
		bifrost: {
			bifrostGroup: 'issue-navigator',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectListServicedeskRouteEntry.tsx',
				whichExportToUse: 'issueNavigatorProjectListServicedeskRouteEntry',
			},
			enabled: true,
			manifestName: 'jira-spa-issue-navigator.json',
		},
		entryPoint: () => issueNavigatorWithoutHorizontalNavPageEntryPoint,
		supportsPreviewPanel: true,
	}),
);
